<template>
  <div>
    <section class="hero is-medium is-warning">
      <div class="hero-body">
        <p class="title">
          Your document signing process is completed.
        </p>
        <p class="subtitle">
          Thank you.
        </p>
      </div>
    </section>
  </div>

</template>

<script>

export default {
  name:'complete-view'
}
</script>
